export default "__VITE_ASSET__CTGmM9nv__"